import { Component, Input } from '@angular/core';
import { ShoppingCartHandlerService } from 'src/app/feature/payment/services';
import { Order } from 'src/app/shared';

@Component({
  selector: 'app-order-status-badge',
  templateUrl: './order-status-badge.component.html',
  styleUrls: ['./order-status-badge.component.scss']
})
export class OrderStatusBadgeComponent {
  @Input() order!: Order;;
  constructor(private shoppingCartHandler: ShoppingCartHandlerService,) {}
  public getDisplayStatus() {
    return this.shoppingCartHandler.getDisplayStatus(this.order);
  }
}
